<template>
  <div class="new-login">
    <h1>
      <a
        href="https://alvaroapoio.com.br/"
        target="_blank"
      >
        <img
          src="/static/images/alvaro-branco.svg"
          alt="AOL 2.0"
        />
      </a>
    </h1>
    <div class="new-login__container">
      <div class="new-login__left">
        <div class="carousel-overlay" />
        <VueSlickCarousel
          :dots="true"
          v-bind="settings"
        >
          <div>
            <img
              src="/static/images/LAB_3.jpg"
              alt=""
            />
          </div>
          <div>
            <img
              src="/static/images/LAB.jpg"
              alt=""
            />
          </div>
          <div>
            <img
              src="/static/images/LAB_2.jpg"
              alt=""
            />
          </div>
        </VueSlickCarousel>
      </div>

      <div class="new-login__form">
        <div
          class="login-box"
          :class="{ flipped: showLoginFields }"
        >
          <div class="card-wrapper">
            <div class="card-front">
              <a
                href="https://alvaroapoio.com.br/"
                target="_blank"
                class="logo"
              >
                <img
                  src="/static/images/logo-alvaro.svg"
                  alt="Laboratório Alvaro"
                />
              </a>

              <div class="card-content">
                <p class="subtitle">Bem vindo ao</p>
                <h2>AOL 2.0</h2>
                <p class="subtitle sub-2">
                  Uma plataforma completa para o dia a dia do seu laboratório
                </p>

                <form
                  class="login-form --step-1"
                  autocomplete="off"
                  @submit.prevent="validateLabId"
                >
                  <div class="input-group">
                    <md-icon class="input-icon">business</md-icon>

                    <div class="lab-input">
                      <span class="lab-prefix">LAB</span>
                      <input
                        v-model="idLab"
                        type="text"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        placeholder="1234"
                        required
                        autocomplete="off"
                        @input="onLabIdInput"
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    class="btn-entrar"
                  >
                    AVANÇAR
                  </button>
                </form>
              </div>

              <div class="help-links">
                <p class="--burgundy">Ainda com dúvida?</p>
                <p>Contate suporte por telefone</p>
                <div class="help-links--contact">
                  <a href="tel:+0800 643 8100">0800 643 8100</a>
                  |
                  <a
                    class="help-link icon-header-decoration"
                    target="_blank"
                    href="https://api.whatsapp.com/send?1=pt_BR&phone=5545988219193"
                  >
                    <md-icon
                      class="whatsapp-icon"
                      md-src="/static/images/icon-whatsapp.svg"
                    />
                    <md-tooltip>Clique para acessar via WhatsApp</md-tooltip>
                  </a>
                </div>
              </div>
            </div>

            <div class="card-back">
              <div class="logo">
                <img
                  src="/static/images/logo-alvaro.svg"
                  alt="Laboratório Alvaro"
                />
              </div>

              <h2>Login</h2>
              <p class="subtitle">Para acessar o sistema efetue o login</p>

              <p
                class="back-to-lab"
                @click.prevent="showLoginFields = false"
              >
                <md-icon>arrow_back</md-icon>
                Laboratório: {{ idLab }}
              </p>
              <form
                class="login-form --step-2"
                autocomplete="on"
              >
                <div class="input-group">
                  <md-icon class="input-icon">person_outline</md-icon>
                  <input
                    v-model="username"
                    type="text"
                    name="username"
                    placeholder="Usuário (E-mail/CPF)"
                    required
                    autocomplete="username"
                  />
                </div>

                <div class="input-group">
                  <md-icon class="input-icon">lock_outline</md-icon>
                  <input
                    v-model="password"
                    type="password"
                    name="password"
                    placeholder="Senha"
                    required
                    autocomplete="current-password"
                  />
                </div>
                <div class="forgot-password">
                  <p @click="resetPassword">Esqueci minha senha</p>
                </div>

                <div class="error-container">
                  <status-message v-if="statusMessages && statusMessages.length > 0" />
                </div>

                <button
                  type="submit"
                  class="btn-entrar"
                  :disabled="disabled || loginLoading"
                  @click.prevent="verifyUserBeforeLogin({ username, password, idLab })"
                >
                  <spinner v-if="loginLoading" />
                  <span v-else>ENTRAR</span>
                </button>
              </form>

              <div
                class="help-links"
                :style="
                  statusMessages && statusMessages.length > 0 ? 'margin-top: 16px;' : ''
                "
              >
                <p class="--burgundy">Ainda com dúvida?</p>
                <p>Contate suporte por telefone</p>
                <div class="help-links--contact">
                  <a href="tel:+0800 643 8100">0800 643 8100</a>
                  |
                  <a
                    class="help-link icon-header-decoration"
                    target="_blank"
                    href="https://api.whatsapp.com/send?1=pt_BR&phone=5545988219193"
                  >
                    <md-icon
                      class="whatsapp-icon"
                      md-src="/static/images/icon-whatsapp.svg"
                    />
                    <md-tooltip>Clique para acessar via WhatsApp</md-tooltip>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <password-reset-modal ref="passwordResetModal" />
    <partners-footer />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import StatusMessages from '@/components/Login/StatusMessages'
import Spinner from '../common/Spinner'
import PasswordResetModal from '../../components/ProfileManagement/components/PasswordResetModal'
import PartnersFooter from './PartnersFooter.vue'

Vue.use(VueReCaptcha, {
  siteKey: '6LcIheEaAAAAAFVkFToGcXPjRkAhcVL-BBR0QpCg',
  loaderOptions: {
    useEnterprise: true,
  },
})

export default {
  name: 'NewLogin',
  components: {
    'status-message': StatusMessages,
    spinner: Spinner,
    PasswordResetModal,
    PartnersFooter,
  },
  data() {
    return {
      idLab: '',
      username: '',
      password: '',
      disabled: false,
      idLabReadonly: true,
      showLoginFields: false,
      isEmailValid: true,
      settings: {
        dots: true,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
      },
    }
  },
  computed: {
    ...mapGetters(['statusMessages', 'loginLoading']),
  },
  methods: {
    ...mapActions(['login']),
    validateLabId() {
      if (this.idLab && this.idLab.trim().length > 0) {
        this.showLoginFields = true
      }
    },
    verifyUserBeforeLogin() {
      if (!this.isEmailValid) return

      const data = {
        idLab: this.idLab.trim(),
        username: this.username.trim(),
        password: this.password.trim(),
      }

      this.recaptcha(data)
    },
    async recaptcha(data) {
      await this.$recaptchaLoaded()
      // const token = await this.$recaptcha('login')
      this.login(data)
      this.$recaptchaInstance.hideBadge()
    },
    resetPassword() {
      this.$refs.passwordResetModal.openPasswordResetModal({
        idLab: this.idLab,
        username: this.username,
      })
    },
    enableIdLab() {
      this.idLabReadonly = false
    },
    onLabIdInput(event) {
      // Remove qualquer caractere que não seja número
      const value = event.target.value.replace(/\D/g, '')
      this.idLab = value
      event.target.value = value
    },
  },
}
</script>

<style lang="scss">
.new-login {
  height: 100vh;
  width: 100vw;
  font-family: 'Exo 2', sans-serif;
  background: linear-gradient(135deg, #f2f6ff 0%, #e5ecff 100%);

  h1 {
    position: absolute;
    left: 60px;
    top: 60px;
    z-index: 2;

    img {
      width: 200px;
      height: auto;
    }
  }

  &__container {
    display: flex;
    height: 100%;
  }

  &__left {
    flex: 2;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    .carousel-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
        to left,
        #e2245a,
        #eb4850,
        #f06649,
        #f28047,
        #f2994a
      );
      opacity: 0.6;
      z-index: 1;
    }

    .slick-slider {
      position: relative;
      z-index: 0;
    }

    .slick-slider,
    .slick-list,
    .slick-track {
      height: 100%;
    }

    .slick-slide {
      height: 100vh;
      div {
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .slick-dots {
      bottom: 25px;
      z-index: 1;

      li button:before {
        color: white;
        font-size: 12px;
      }

      li.slick-active button:before {
        color: white;
      }
    }
  }

  &__form {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 2;
    right: 80px;
    top: calc(
      50vh - 280px - 74px
    ); // altura menos a metade da altura do card, menos metade do rodape

    @media screen and (max-width: 1366px) {
      right: 5vw;
      top: calc(
        50vh - 280px
      ); // altura menos a metade da altura do card, menos metade do rodape
    }

    .back-to-lab {
      margin: 15px 0 4px;

      i {
        cursor: pointer;
      }
    }

    .login-box {
      position: relative;
      width: 420px;
      min-height: 560px;
      opacity: 0;
      animation: slideInFromRight 0.5s forwards;

      @media screen and (max-width: 767px) {
        width: 90vw;
        min-height: 580px;
      }

      &.flipped .card-wrapper {
        transform: rotateY(180deg);
      }

      .card-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;
        transition: transform 0.8s;
        perspective: 1000px;
      }

      .card-front,
      .card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 40px;
        background: white;
        border-radius: 25px;
        backface-visibility: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;

        .logo {
          display: flex;
          justify-content: center;
          margin-bottom: 24px;

          img {
            width: 170px;
            height: auto;
          }
        }

        h2 {
          font-size: 32px;
          color: #7f1a54;
          margin-bottom: 8px;
        }

        .subtitle {
          color: #666;
          margin-bottom: 4px;

          &.sub-2 {
            margin-top: 8px;
            margin-bottom: 24px;
          }
        }

        .login-form {
          &.--step-1 {
            margin-top: 50px;

            .btn-entrar {
              margin: 0;
            }
          }

          &.--step-2 {
            .btn-entrar {
              margin-top: 10px;
            }
          }

          .input-group {
            position: relative;
            margin-bottom: 20px;

            .input-icon {
              position: absolute;
              left: 12px;
              top: 50%;
              transform: translateY(-50%);
              color: #666;
              z-index: 1;
            }

            input {
              width: 100%;
              padding: 12px 12px 12px 44px;
              border: 1px solid #ddd;
              border-radius: 5px;
              font-size: 16px;
              outline: none;
              transition: border-color 0.2s;

              &:focus {
                border-color: #7f1a54;
              }
            }

            &:nth-child(2) {
              margin-bottom: 0;
            }
          }

          .btn-entrar {
            width: 100%;
            background: #7f1a54;
            color: white;
            border: none;
            border-radius: 5px;
            padding: 14px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: opacity 0.2s;
            margin-top: 24px;
            font-family: 'Exo 2', sans-serif;
            letter-spacing: 1px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              opacity: 0.9;
            }

            &:disabled {
              opacity: 0.7;
              cursor: not-allowed;
            }
          }
        }

        .help-links {
          margin-top: 32px;
          text-align: center;
          color: #666;
          font-size: 14px;

          &--contact {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
          }

          p {
            margin: 8px 0;

            &.--burgundy {
              color: #7f1a54;
            }
          }

          a {
            color: #7f1a54;
            text-decoration: none;
            font-weight: 500;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .card-back {
        transform: rotateY(180deg);
      }

      .card-content {
        flex: 1;
      }
    }

    .forgot-password {
      color: #7f1a54;
      font-size: 13px;
      font-weight: 500;
      margin-top: 4px;
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-end;

      p {
        cursor: pointer;
      }
    }
  }

  @keyframes slideInFromRight {
    from {
      opacity: 0;
      transform: translateX(100px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .lab-input {
    position: relative;
    width: 100%;

    .lab-prefix {
      position: absolute;
      left: 44px;
      top: 50%;
      transform: translateY(-50%);
      color: #666;
      font-weight: 500;
      pointer-events: none;
    }

    input {
      width: 100%;
      padding: 12px 12px 12px 85px !important;
    }
  }

  .loader {
    height: 28px;
    width: 28px;
    border-top: 0.5em solid rgba(127, 26, 84, 0.2);
    border-right: 0.5em solid rgba(127, 26, 84, 0.2);
    border-bottom: 0.5em solid rgba(127, 26, 84, 0.2);
    border-left: 0.5em solid #ffffff;
  }
}
</style>
